<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
            :setDates="true"
            :disabled="loadedReport"
        />
      </v-col>
      <v-spacer></v-spacer>
      <last-time-updated :selectedDate="'updateCopper'" class=" mt-0 mt-md-4"/>
    </v-row>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row class="pa-0">
        <v-progress-linear indeterminate color="indigo" v-if="loadedReport"></v-progress-linear>
        <v-col cols="12" md="6" :lg="12/statisticСards.length" class="d-flex justify-start justify-lg-center" v-for="(e, i) in statisticСards" :key="i">
          <div class="d-flex flex-column">
            <div class="d-flex align-end" v-for="(card, index) in statisticСards[i]" :key="index">
              <b class="pr-1">{{card.title}}: </b>
              <span v-if="!loadedReport && card.filter === 'formatPrice'">${{ statistic[card.value] | formatPrice }}</span>
              <span v-if="!loadedReport && card.filter === 'formatFloat'">{{ statistic[card.value] | formatFloat }}</span>
              <div v-if="showFilteredStatistic && card.filtered" class="text-caption primary--text ml-1"> {{ statisticFiltered[card.value] | formatFloat }}</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0">
          <v-text-field
            dense
            v-model="searchPotentialGallons"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn
          color="indigo"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFiltersPotentialGallons"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" md="6" lg="3" class="pa-0 mr-auto" v-for="(e, i) in potentialGallonsСards" :key="i">
          <v-autocomplete
            dense
            v-model="filteredPotentialGallons[`${e.filtered}`]"
            :items="filtersPotentialGallons[`${e.filters}`]"
            :menu-props="{ maxHeight: '200' }"
            multiple
            outlined
            :class="['mr-md-1', {'v-input--is-focused primary--text' : filteredPotentialGallons[`${e.filtered}`].length}]"
            @change="fetchFiltersPotentialGallons"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="grey darken-4" class="grey lighten-3">
                <span >{{ item }}</span>
              </v-chip>
              <span
                v-if="index === 2"
                class="grey--text chip-counter"
              >
                (+{{ filteredPotentialGallons[`${e.filtered}`].length - 2 }} {{ (filteredPotentialGallons[`${e.filtered}`].length - 2) > 1 ? 'others' : 'another' }})
              </span>
              <v-chip text-color="white" :class="item.value" v-if="e.tooltip">
                <span>{{ item.text }}</span>
              </v-chip>
            </template>
            <template v-slot:label>
              <p :class="filteredPotentialGallons[`${e.filtered}`].length ? 'primary--text' : ''">{{ e.name }}</p>
            </template>
            <template v-slot:item="{ active, item, on, attrs }" v-if="e.tooltip">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.text }}</span>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" :color="item.value" small>mdi-information-outline</v-icon>
                        </template>
                        <span v-html="item.tooltip"></span>
                      </v-tooltip>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-col cols="4" class="py-0 d-flex">
          <h2 class="pl-3">Potential Gallons</h2>
        </v-col>
        <v-col cols="8" class="py-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataPotentialGallonsForExcel"
            :columns="columnsDataPotentialGallons"
            :filename="`${settingsName}PotentialGallons`"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"
                min-width="39px"
                :disabled="dataPotentialGallons.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"
                color="white"
              >
                <ExportExcel />
              </v-btn>
          </vue-excel-xlsx>
          <CustomColumns
            :currentValue="valuePotentialGallons"
            :currentCustomHeader="customHeaderPotentialGallons"
            :currentHeaders="headersPotentialGallons"
            :settingsName="`${settingsName}PotentialGallons`"
            @getCustomData="getCustomDataPotentialGallons"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTablePotentialGallons">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-cpr-ltp"
              fab
              small
              @click="scrollingLeftPotentialGallons"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-cpr-ltp"
              fab
              small
              @click="scrollingRightPotentialGallons"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, -1]
                }"
              :items-per-page="10"
              dense
              :headers="selectedHeadersPotentialGallons"
              :items="dataFilteredPotentialGallons"
              :page.sync="pagination.page"
              item-key="id"
              class="elevation-0 mt-2"
              :loading="loadedReport"
              loading-text="Loading... Please wait"
              @click:row="rowClick"
              :search="searchPotentialGallons"
          >
            <template v-slot:item.id="{ item }">
              <span v-if="item.recording_url"><a target="_blank" :href="item.recording_url">{{ item.id }}</a></span>
              <span v-else>{{ item.id }}</span>
            </template>
            <template v-slot:item.status_p="{ item }">
              <v-select :items="['Potential', 'Quote', 'Order', 'Lost', 'Abounded', 'Duplicate']" dense v-model="item.status_p" @change="changeStatusPotential(item)" @click.native="clickStatusPotential"/>
            </template>
            <template v-slot:item.customer_name="{ item }">
              <span v-if="item.people_id>0">
                <a v-if="item.type_copper == 'people'" target="_blank" :href="`https://app.copper.com/companies/243221/app/#/contact/`+item.people_id ">{{ item.customer_name }}</a>
                <a v-else target="_blank" :href="`https://app.copper.com/companies/243221/app/#/lead/`+item.people_id ">{{ item.customer_name }}</a>
              </span>
              <span v-else>{{ item.customer_name }}</span>
            </template>
            <template v-slot:item.last_activity_record="{ item }">
              <div v-if="item.last_activity_record.date !== ''">
                <p style="margin-bottom: 0">Date: {{item.last_activity_record.date}}</p>
                <p style="margin-bottom: 0"><b>{{item.last_activity_record.title}}</b></p>
                <p style="margin-bottom: 0">{{item.last_activity_record.content}}</p>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex flex-column">
                <v-icon
                    small
                    v-text="'Quote'"
                    @click.stop.prevent="editQuote(item)"
                ></v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0">
          <v-text-field
            dense
            v-model="searchOpenOpportunities"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn
          color="indigo"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFiltersOpenOpportunities"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>
      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" md="6" lg="2" class="pa-0 mr-auto" v-for="(e, i) in openOpportunitiesСards" :key="i">
          <v-autocomplete
            dense
            v-model="filteredOpenOpportunities[`${e.filtered}`]"
            :items="filtersOpenOpportunities[`${e.filters}`]"
            :menu-props="{ maxHeight: '200' }"
            multiple
            outlined
            :class="['mr-md-1', {'v-input--is-focused primary--text' : filteredOpenOpportunities[`${e.filtered}`].length}]"
            @change="fetchFiltersOpenOpportunities"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="grey darken-4" class="grey lighten-3">
                <span >{{ item }}</span>
              </v-chip>
              <span
                v-if="index === 2"
                class="grey--text chip-counter"
              >
                (+{{ filteredOpenOpportunities[`${e.filtered}`].length - 2 }} {{ (filteredOpenOpportunities[`${e.filtered}`].length - 2) > 1 ? 'others' : 'another' }})
              </span>
              <v-chip text-color="white" :class="item.value" v-if="e.tooltip">
                <span>{{ item.text }}</span>
              </v-chip>
            </template>
            <template v-slot:label>
              <p :class="filteredOpenOpportunities[`${e.filtered}`].length ? 'primary--text' : ''">{{ e.name }}</p>
            </template>
            <template v-slot:item="{ active, item, on, attrs }" v-if="e.tooltip">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row no-gutters align="center">
                      <span>{{ item.text }}</span>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" :color="item.value" small>mdi-information-outline</v-icon>
                        </template>
                        <span v-html="item.tooltip"></span>
                      </v-tooltip>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-col cols="4" class="py-0 d-flex">
          <h2 class="pl-3">Open Opportunities</h2>
        </v-col>
        <v-col cols="8" class="py-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataOpenOpportunitiesForExcel"
            :columns="columnsDataOpenOpportunities"
            :filename="`${settingsName}Opportunity`"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"
                min-width="39px"
                :disabled="dataOpenOpportunities.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"
                color="white"
              >
                <ExportExcel />
              </v-btn>
          </vue-excel-xlsx>
          <CustomColumns
            :currentValue="valueOpenOpportunities"
            :currentCustomHeader="customHeaderOpenOpportunities"
            :currentHeaders="headersOpenOpportunities"
            :settingsName="`${settingsName}Opportunity`"
            @getCustomData="getCustomDataOpenOpportunities"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTableOpenOpportunities">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-cpr-opp"
              fab
              small
              @click="scrollingLeftOpenOpportunities"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-cpr-opp"
              fab
              small
              @click="scrollingRightOpenOpportunities"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, -1]
                }"
              :items-per-page="10"
              dense
              :headers="selectedHeadersOpenOpportunities"
              :items="dataFilteredOpenOpportunities"
              :page.sync="pagination.page"
              item-key="id"
              class="elevation-0 mt-2"
              :loading="loadedReport"
              loading-text="Loading... Please wait"
              @click:row="rowClick"
              :search="searchOpenOpportunities"
          >
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
    <v-dialog v-model="dialogEditQuote" max-width="500px">
              <v-card>
                <v-card-title class="headline">
                  Quote
                </v-card-title>
                <v-card-text>
                  <v-text-field label="Name" v-model="quote.name"/>
                  <v-text-field label="Activity" v-model="quote.activity"/>
                  <DateFilter label="Created Date" :start="quote.createdDate" @getDates="getDate"/>
                  <v-text-field label="Comments" v-model="quote.comments"/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="closeEditQuote"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    text
                    :disabled="quote.name === '' ? true : false"
                    @click="saveEditQuote"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import LastTimeUpdated from "@/views/LastTimeUpdated"
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import DateFilter from '@/components/filters/DateFilter'

export default {
  components: {
    LastTimeUpdated,
    RangeFilter,
    CustomColumns,
    ExportExcel,
    DateFilter
  },
  data() {
    return {
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      pagination: {
        page: 1
      },
      dialogEditQuote:false,
      quote: {
        activity: "",
        createdDate: "",
        name: "",
        comments: ""
      },
      loadedReport: false,
      dataPotentialGallons: [],
      dataCopper: [],
      dataOpenOpportunities: [],
      statistic: {
        totalOpenOpportunities: 0,
        totalValue: 0,
        totalGallons: 0,
        totalPotentialGallons: 0,
        totalCall: 0,
        totalWeb: 0
      },
      statisticFiltered: {
        converted: 0,
        totalValue: 0,
        totalGallons: 0,
        totalPotentialGallons: 0,
        totalCall: 0,
        totalWeb: 0
      },
      headersOpenOpportunities: [
        {text: 'Date', value: 'created_at', class: 'black--text'},
        {text: 'Name', value: 'op_name', class: 'black--text'},
        {text: 'Contact', value: 'contact', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Value', value: 'price_value', class: 'black--text'},
        {text: 'Interactions', value: 'interactions', class: 'black--text'},
        {text: 'Inactivity days', value: 'inactive_days', class: 'black--text'},
        {text: 'Owner', value: 'owner', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Tags', value: 'tags', class: 'black--text'}
      ],
      valueOpenOpportunities: [
        {text: 'Date', value: 'created_at', class: 'black--text'},
        {text: 'Name', value: 'op_name', class: 'black--text'},
        {text: 'Contact', value: 'contact', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Value', value: 'price_value', class: 'black--text'},
        {text: 'Interactions', value: 'interactions', class: 'black--text'},
        {text: 'Inactivity days', value: 'inactive_days', class: 'black--text'},
        {text: 'Owner', value: 'owner', class: 'black--text'},
        {text: 'Status', value: 'status', class: 'black--text'},
        {text: 'Tags', value: 'tags', class: 'black--text'}
      ],
      headersPotentialGallons: [
        {text: 'Lead Date', value: 'lead_date', class: 'black--text'},
        {text: 'Id', value: 'id', class: 'black--text'},
        {text: 'Customer Name', value: 'customer_name', class: 'black--text'},
        {text: 'Company', value: 'customer_company', class: 'black--text'},
        {text: 'Ship Address', value: 'ship_addr', class: 'black--text'},
        {text: 'Email', value: 'email', class: 'black--text'},
        {text: 'Product', value: 'fo_product', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Project Info', value: 'project_info', class: 'black--text'},
        {text: 'Type', value: 'type', class: 'black--text'},
        {text: 'CallRail Operator', value: 'call_operator', class: 'black--text'},
        {text: 'Phone #', value: 'phone', class: 'black--text'},
        {text: 'Keyword', value: 'keyword', class: 'black--text'},
        {text: 'Campaign', value: 'campaign', class: 'black--text'},
        {text: 'Has Follow up', value: 'has_followup', class: 'black--text'},
        {text: 'Has Order', value: 'has_order', class: 'black--text'},
        {text: 'Has Quote', value: 'has_quote', class: 'black--text'},
        {text: 'Last Activity Record', value: 'last_activity_record', class: 'black--text'},
        {text: 'Status', value: 'status_p', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
      ],
      valuePotentialGallons: [
        {text: 'Lead Date', value: 'lead_date', class: 'black--text'},
        {text: 'Id', value: 'id', class: 'black--text'},
        {text: 'Customer Name', value: 'customer_name', class: 'black--text'},
        {text: 'Company', value: 'customer_company', class: 'black--text'},
        {text: 'Ship Address', value: 'ship_addr', class: 'black--text'},
        {text: 'Email', value: 'email', class: 'black--text'},
        {text: 'Product', value: 'fo_product', class: 'black--text'},
        {text: 'Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Project Info', value: 'project_info', class: 'black--text'},
        {text: 'Type', value: 'type', class: 'black--text'},
        {text: 'Phone #', value: 'phone', class: 'black--text'},
        {text: 'Keyword', value: 'keyword', class: 'black--text'},
        {text: 'Campaign', value: 'campaign', class: 'black--text'},
        {text: 'Has Follow up', value: 'has_followup', class: 'black--text'},
        {text: 'Has Order', value: 'has_order', class: 'black--text'},
        {text: 'Has Quote', value: 'has_quote', class: 'black--text'},
        {text: 'Last Activity Record', value: 'last_activity_record', class: 'black--text'},
        {text: 'Status', value: 'status_p', class: 'black--text'},
        {text: 'Actions', value: 'actions', class: 'black--text', sortable: false},
      ],
      customHeaderPotentialGallons: ['lead_date', 'id', 'customer_name', 'customer_company',
                          'ship_addr', 'email', 'fo_product', 'gallons', 'project_info', 'type',
                          'phone', 'keyword', 'campaign', 'has_order', 'has_quote', 'call_operator', 'has_followup',
                          'last_activity_record', 'status_p'],
      customHeaderOpenOpportunities: ['created_at', 'op_name', 'contact', 'company_name',
                          'gallons', 'price_value', 'interactions', 'inactive_days',
                          'owner', 'status', 'tags'],
      selectedHeadersPotentialGallons: [],
      selectedHeadersOpenOpportunities: [],
      settingsName: 'potentialReport',
      columnsDataPotentialGallons: [],
      columnsDataOpenOpportunities: [],
      hoverOnTableOpenOpportunities: false,
      hoverOnTablePotentialGallons: false,
      statisticСards: [
        [
         {title: 'Total Potential Gallons', value: 'totalPotentialGallons', loaded: 'loadedReport', filter: 'formatFloat', filtered: true},
         {title: 'Total Call Rail', value: 'totalCall', loaded: 'loadedReport', filter: 'formatFloat', filtered: true},
         {title: 'Total Web Inquiry', value: 'totalWeb', loaded: 'loadedReport', filter: 'formatFloat', filtered: true},
        ],
        [
          {title: 'Total Open Opportunities', value: 'totalOpenOpportunities', loaded: 'loadedReport', filter: 'formatFloat', filtered: true},
          {title: 'Total Gallons', value: 'totalGallons', loaded: 'loadedReport', filter: 'formatFloat', filtered: true},
          {title: 'Total Value', value: 'totalValue', loaded: 'loadedReport', filter: 'formatFloat', filtered: true}
        ],
      ],
      filteredOpenOpportunities: {
        'owner': [],
        'contact': [],
        'company_name': []
      },
      filtersOpenOpportunities: {
        'owner': [],
        'contact': [],
        'company_name': []
      },
      filteredPotentialGallons: {
        'type': [],
        'fo_product': [],
        'customer_name': [],
        'customer_company': [],
        'has_order': [],
        'has_quote': [],
        'has_followup': [],
        'status_p': []
      },
      filtersPotentialGallons: {
        'type': [],
        'fo_product': [],
        'customer_name': [],
        'customer_company': [],
        'has_order': [],
        'has_quote': [],
        'has_followup': [],
        'status_p': []
      },
      openOpportunitiesСards: [
        {name: 'Owner Filter', filtered: 'owner', filters: 'owner'},
        {name: 'Contact Filter', filtered: 'contact', filters: 'contact'},
        {name: 'Company Filter', filtered: 'company_name', filters: 'company_name'},
      ],
      potentialGallonsСards: [
        {name: 'Type Filter', filtered: 'type', filters: 'type'},
        {name: 'Product Filter', filtered: 'fo_product', filters: 'fo_product'},
        {name: 'Customer Filter', filtered: 'customer_name', filters: 'customer_name'},
        {name: 'Company Filter', filtered: 'customer_company', filters: 'customer_company'},
        {name: 'Order Filter', filtered: 'has_order', filters: 'has_order'},
        {name: 'Quote Filter', filtered: 'has_quote', filters: 'has_quote'},
        {name: 'Follow up Filter', filtered: 'has_followup', filters: 'has_followup'},
        {name: 'Status Filter', filtered: 'status_p', filters: 'status_p'},
      ],
      searchOpenOpportunities: '',
      searchPotentialGallons: ''
    }
  },
  watch: {
    valuePotentialGallons(val) {
      this.selectedHeadersPotentialGallons = val
      this.getHeaderForExcel()
    },
    valueOpenOpportunities(val) {
      this.selectedHeadersOpenOpportunities = val
      this.getHeaderForExcel()
    },
    hoverOnTableOpenOpportunities() {
      this.showScrollingArrowsOpenOpportunities()
    },
    hoverOnTablePotentialGallons() {
      this.showScrollingArrowsPotentialGallons()
    },
    searchOpenOpportunities(){
      let data = this.dataFilteredOpenOpportunities.filter(e => {
        let obj = Object.values(e).map(e => (e && typeof e != 'object') ? e.toString().toLowerCase() : '')
        return obj.some(i => i.match(this.searchOpenOpportunities.toLowerCase()))
      })
      this.statisticFiltered.totalOpenOpportunities = data.length
      this.statisticFiltered.totalGallons = data.reduce((acc, e) => acc + e.gallons, 0)
      this.statisticFiltered.totalValue = data.reduce((acc, e) => acc + e.price_value, 0)
    },
    searchPotentialGallons(){
      let data = this.dataFilteredPotentialGallons.filter(e => {
        let obj = Object.values(e).map(e => (e && typeof e != 'object') ? e.toString().toLowerCase() : '')
        return obj.some(i => i.match(this.searchPotentialGallons.toLowerCase()))
      })

      this.statisticFiltered.totalPotentialGallons = data.reduce((acc, e) => acc+e.gallons, 0)
      this.statisticFiltered.totalCall = data.reduce((acc, e) => (e.type == 'Call Rail') ? acc+1 : acc, 0)
      this.statisticFiltered.totalWeb = data.reduce((acc, e) => (e.type != 'Call Rail') ? acc+1 : acc, 0)
    }
  },
  created() {
    this.selectedHeadersPotentialGallons = this.valuePotentialGallons
    this.selectedHeadersOpenOpportunities = this.valueOpenOpportunities
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrowsOpenOpportunities)
    window.addEventListener("resize", this.showScrollingArrowsPotentialGallons)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrowsOpenOpportunities)
    window.removeEventListener("resize", this.showScrollingArrowsPotentialGallons)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('potential-gallon')) {
      let data = JSON.parse(localStorage.getItem('potential-gallon'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('potential-gallon')
    }

    this.applyFilters()

    let userName = localStorage.getItem('username')
    let settings = this.settingsName
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1

    if (localStorage.getItem(`${userName}.${clientId}.${settings}Opportunity`)) {
      try {
        let valueOpenOpportunitiesCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Opportunity`))
        this.valueOpenOpportunities = valueOpenOpportunitiesCash.filter(e => this.headersOpenOpportunities.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.valueOpenOpportunities)
        localStorage.setItem(`${userName}.${clientId}.${settings}Opportunity`, parsed)


        this.customHeaderOpenOpportunities = this.valueOpenOpportunities.map(e => e.value)
      } catch(e) {
        console.log("")
      }
    }

    if (localStorage.getItem(`${userName}.${clientId}.${settings}PotentialGallons`)) {
      try {
        let valuePotentialGallonsCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}PotentialGallons`))
        this.valuePotentialGallons = valuePotentialGallonsCash.filter(e => this.headersPotentialGallons.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.valuePotentialGallons)
        localStorage.setItem(`${userName}.${clientId}.${settings}PotentialGallons`, parsed)


        this.customHeaderPotentialGallons = this.valuePotentialGallons.map(e => e.value)
      } catch(e) {
        console.log("")
      }
    }

    this.showScrollingArrowsOpenOpportunities()
    this.showScrollingArrowsPotentialGallons()
  },
  computed: {
    dataOpenOpportunitiesForExcel() {
      if (!this.dataFilteredOpenOpportunities) return []
      return JSON.parse(JSON.stringify(this.dataOpenOpportunities))
    },
    dataPotentialGallonsForExcel() {
      if (!this.dataFilteredPotentialGallons) return []
      return JSON.parse(JSON.stringify(this.dataFilteredPotentialGallons))
    },
    dataFilteredOpenOpportunities() {
      return this.dataOpenOpportunities.filter(d => {
        return Object.keys(this.filteredOpenOpportunities).every(f => {
          if(Array.isArray(d[f])){ // custom filter for product type
            let names = this._.map(d[f], p => {return p.name})
            for (let n of names){
              if (this.filteredOpenOpportunities[f].includes(n)){
                return this.filteredOpenOpportunities[f].length < 1 || this.filteredOpenOpportunities[f].includes(n)
              }
            }
          }
          return this.filteredOpenOpportunities[f].length < 1 || this.filteredOpenOpportunities[f].includes(d[f])
        })
      })
    },
    dataFilteredPotentialGallons(){
      return this.dataPotentialGallons.filter(d => {
        return Object.keys(this.filteredPotentialGallons).every(f => {
          if(Array.isArray(d[f])){ // custom filter for product type
            let names = this._.map(d[f], p => {return p.name})
            for (let n of names){
              if (this.filteredPotentialGallons[f].includes(n)){
                return this.filteredPotentialGallons[f].length < 1 || this.filteredPotentialGallons[f].includes(n)
              }
            }
          }
          return this.filteredPotentialGallons[f].length < 1 || this.filteredPotentialGallons[f].includes(d[f])
        })
      })
    },
    showFilteredStatistic(){
      return Object.values(this.filteredOpenOpportunities).some(e => e.length) || this.searchOpenOpportunities.length ||
      Object.values(this.filteredPotentialGallons).some(e => e.length) || this.searchPotentialGallons.length
    }
  },
  methods: {
    clickStatusPotential(e){
      e.preventDefault();
      e.stopPropagation();
    },
    changeStatusPotential(item){
      axios.post('/potential-gallons/status', {externalId: item.id, status: item.status_p})
      this.fetchFiltersPotentialGallons()
    },
    editQuote(item){
      this.dialogEditQuote = true
      this.quote = {
        id: item.quote_id ?? 0,
        externalId: item.id,
        activity: item.quote_activity ?? '',
        createdDate: item.quote_date ?? '',
        name: item.quote_name ?? '',
        comments: item.quote_comments ?? ''
      }
    },
    getDate(dates) {
      this.quote.createdDate = dates.dateStart
    },
    closeEditQuote(){
      this.dialogEditQuote = false
    },
    saveEditQuote(){
      this.dialogEditQuote = false
      axios.post('/potential-gallons/quote', this.quote).then(() => {
          this.applyFilters()
      })
    },
    scrollingRightOpenOpportunities() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-cpr-opp')
      const btnLeft = document.querySelector('.btn-left-arrow-cpr-opp')
      btnRight.style.visibility = (this.hoverOnTableOpenOpportunities && (el[1].scrollLeft + el[1].clientWidth != el[1].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableOpenOpportunities ? 'visible' : 'hidden'
    },
    scrollingLeftOpenOpportunities() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-cpr-opp')
      const btnRight = document.querySelector('.btn-right-arrow-cpr-opp')
      btnLeft.style.visibility = (this.hoverOnTableOpenOpportunities && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableOpenOpportunities ? 'visible' : 'hidden'
    },
    showScrollingArrowsOpenOpportunities() {
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightOpenOpportunities = document.querySelector('.btn-right-arrow-cpr-opp')
      const btnLeftOpenOpportunities = document.querySelector('.btn-left-arrow-cpr-opp')
      btnRightOpenOpportunities.style.visibility = (this.hoverOnTableOpenOpportunities && (el[1].scrollLeft + el[1].clientWidth !== el[1].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftOpenOpportunities.style.visibility = (this.hoverOnTableOpenOpportunities && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    scrollingRightPotentialGallons() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[0].scrollLeft = el[0].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-cpr-ltp')
      const btnLeft = document.querySelector('.btn-left-arrow-cpr-ltp')
      btnRight.style.visibility = (this.hoverOnTablePotentialGallons && (el[0].scrollLeft + el[0].clientWidth != el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTablePotentialGallons ? 'visible' : 'hidden'
    },
    scrollingLeftPotentialGallons() {
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[0].scrollLeft = el[0].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-cpr-ltp')
      const btnRight = document.querySelector('.btn-right-arrow-cpr-ltp')
      btnLeft.style.visibility = (this.hoverOnTablePotentialGallons && (el[0].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTablePotentialGallons ? 'visible' : 'hidden'
    },
    showScrollingArrowsPotentialGallons() {
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightPotentialGallons = document.querySelector('.btn-right-arrow-cpr-ltp')
      const btnLeftPotentialGallons = document.querySelector('.btn-left-arrow-cpr-ltp')
      btnRightPotentialGallons.style.visibility = (this.hoverOnTablePotentialGallons && (el[0].scrollLeft + el[0].clientWidth !== el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftPotentialGallons.style.visibility = (this.hoverOnTablePotentialGallons && (el[0].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    applyFilters() {
      this.loadedReport = true
      axios
          .get('/reports/potential-gallons/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.dataCopper = response.data.data
            this.dataPotentialGallons = response.data.potential_gallons
            this.dataOpenOpportunities = response.data.opportunity
            this.statistic.totalGallons = this.dataOpenOpportunities.reduce((acc, e) => acc+e.gallons, 0)
            this.statistic.totalValue = this.dataOpenOpportunities.reduce((acc, e) => acc+e.price_value, 0)
            this.statistic.totalOpenOpportunities = this.dataOpenOpportunities.length

            this.statistic.totalPotentialGallons = this.dataPotentialGallons.reduce((acc, e) => acc+e.gallons, 0)
            this.statistic.totalCall = this.dataPotentialGallons.reduce((acc, e) => (e.type == 'Call Rail') ? acc+1 : acc, 0)
            this.statistic.totalWeb = this.dataPotentialGallons.reduce((acc, e) => (e.type != 'Call Rail') ? acc+1 : acc, 0)

            this.fetchFiltersOpenOpportunities()
            this.fetchFiltersPotentialGallons()
            this.loadedReport = false
          })
    },
    fetchFiltersOpenOpportunities() {
      this.filtersOpenOpportunities.owner = this._.compact(this.dataOpenOpportunities
              .map(e => e.owner)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersOpenOpportunities.contact = this._.compact(this.dataOpenOpportunities
              .map(e => e.contact)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersOpenOpportunities.company_name = this._.compact(this.dataOpenOpportunities
              .map(e => e.company_name)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.statisticFiltered.totalGallons = this.dataFilteredOpenOpportunities.reduce((acc, e) => acc+e.gallons, 0)
      this.statisticFiltered.totalValue = this.dataFilteredOpenOpportunities.reduce((acc, e) => acc+e.price_value, 0)
      this.statisticFiltered.totalOpenOpportunities = this.dataFilteredOpenOpportunities.length
    },
    fetchFiltersPotentialGallons() {
      this.filtersPotentialGallons.type = this._.compact(this.dataPotentialGallons
              .map(e => e.type)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.fo_product = this._.compact(this.dataPotentialGallons
              .map(e => e.fo_product)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.customer_name = this._.compact(this.dataPotentialGallons
              .map(e => e.customer_name)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.customer_company = this._.compact(this.dataPotentialGallons
              .map(e => e.customer_company)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.has_order = this._.compact(this.dataPotentialGallons
              .map(e => e.has_order)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.has_quote = this._.compact(this.dataPotentialGallons
              .map(e => e.has_quote)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.has_followup = this._.compact(this.dataPotentialGallons
              .map(e => e.has_followup)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.filtersPotentialGallons.status_p = this._.compact(this.dataPotentialGallons
              .map(e => e.status_p)
              .filter((x, i, a) => a.indexOf(x) == i))
              .sort((a, b) => a.localeCompare(b))

      this.statisticFiltered.totalPotentialGallons = this.dataFilteredPotentialGallons.reduce((acc, e) => acc+e.gallons, 0)
      this.statisticFiltered.totalCall = this.dataFilteredPotentialGallons.reduce((acc, e) => (e.type == 'Call Rail') ? acc+1 : acc, 0)
      this.statisticFiltered.totalWeb = this.dataFilteredPotentialGallons.reduce((acc, e) => (e.type != 'Call Rail') ? acc+1 : acc, 0)
    },
    cleanFiltersOpenOpportunities(){
      this.searchOpenOpportunities = ''

      this.filteredOpenOpportunities.owner = []
      this.filteredOpenOpportunities.contact = []
      this.filteredOpenOpportunities.company_name = []
    },
    cleanFiltersPotentialGallons(){
      this.searchPotentialGallons = ''

      this.filteredPotentialGallons.type = []
      this.filteredPotentialGallons.fo_product = []
      this.filteredPotentialGallons.customer_name = []
      this.filteredPotentialGallons.customer_company = []
    },
    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getCustomDataOpenOpportunities({customHeader, value, selectedHeaders}){
      this.customHeaderOpenOpportunities = customHeader
      this.valueOpenOpportunities = value
      this.selectedHeadersOpenOpportunities = selectedHeaders
    },
    getCustomDataPotentialGallons({customHeader, value, selectedHeaders}){
      this.customHeaderPotentialGallons = customHeader
      this.valuePotentialGallons = value
      this.selectedHeadersPotentialGallons = selectedHeaders
    },
    getHeaderForExcel(){
      this.columnsDataOpenOpportunities = this.selectedHeadersOpenOpportunities.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        return obj
      })

      this.columnsDataPotentialGallons = this.selectedHeadersPotentialGallons.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        return obj
      })
    },
  }
}
</script>


<style scoped>
  .btn-right-arrow-cpr-opp,
  .btn-right-arrow-cpr-ltp {
    right: 0px;
    top: 65px;
  }
  .btn-left-arrow-cpr-opp,
  .btn-left-arrow-cpr-ltp {
    left: 0px;
    top: 65px;
  }
.v-application .text-caption {
  line-height: 1.5rem;
}
</style>
